import { useState, useEffect } from 'react'
import { MenuTabs, PropertyMenu } from 'components'
import Flex from 'components/priority/Flex/Flex'
import { rightMenuAtom, roleAtom } from 'atoms'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import zLayers from 'utils/styling/zLayers'
import { isBulkProcessingAtom } from '@/atoms/_editorAtoms'

export const PropertiesMenu = () => {
  const [activeTab, setActiveTab] = useState('Elements')
  const setRightMenu = useSetRecoilState(rightMenuAtom)
  const userRole = useRecoilValue(roleAtom)
  const isBulkProcessing = useRecoilValue(isBulkProcessingAtom)

  const isFhUser = userRole === 'fh-user'

  useEffect(() => {
    setRightMenu(activeTab)
    //eslint-disable-next-line
  }, [activeTab])

  const adminTabs = ['Elements', 'Background', 'Settings']
  const userTabs = ['Elements', 'Settings']
  const tabs = isFhUser ? userTabs : adminTabs

  return (
    <Flex
      column
      justify="space-between"
      height="100%"
      width="250px"
      background="white"
      zindex={zLayers.base}
      borderLeft="1px solid"
      borderColor="gray4"
      data-editor-ui="properties-menu"
      pointerEvents={isBulkProcessing ? 'none' : 'auto'}
    >
      <MenuTabs activeTab={[activeTab, setActiveTab]} tabs={tabs} />
      <PropertyMenu activeTab={activeTab} />
      {/* <GiveFeedback /> */}
      {/*  NOTE: This component will be eventually reused but its functionality will change */}
    </Flex>
  )
}

export default PropertiesMenu
